export default __webpack_public_path__ + "static/media/points-64-gold.1c5c5404.png";